import { Fragment } from 'react';
import { cardSrc, parseTeenCards } from './resultParsers';

const WINNER_ICON = 'https://wver.sprintstaticdata.com/v230/static/front/img/winner.png';

// Queen Top Open Teenpatti (teen41) result — reference: row row5 > col-lg-7
// (casino-result-content, h4 cards ke bahar, cards A=0,2,4 / B=1,3,5, winning
// side ka pehla item winner-icon) + col-lg-5 (casino-result-desc: Winner +
// Under/Over). rdesc = "<winner>#<under/over>" (e.g. "Player B#B : (21)").
export default function Teen41Result({ detail }) {
  const cards = parseTeenCards(detail?.card);
  const win = String(detail?.win ?? '');
  const winnat = detail?.winnat || '';
  const isAWinner = win === '1' || winnat === 'Player A';
  const isBWinner = win === '2' || winnat === 'Player B';

  const parts = String(detail?.rdesc || '').split('#');
  const winner = winnat || parts[0] || (isAWinner ? 'Player A' : isBWinner ? 'Player B' : '');
  const underOver = parts[1] || '';

  const side = (title, list, isWinner) => (
    <div className="casino-result-content-item text-center">
      <h4>{title}</h4>
      {' '}
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={WINNER_ICON} className="winner-icon" />
          </div>
        )}
        {' '}
        {list.map((code, i) => (
          <Fragment key={i}>
            <div className="casino-result-cards-item">
              <img src={cardSrc(code)} />
            </div>
            {' '}
          </Fragment>
        ))}
      </div>
    </div>
  );

  return (
    <div className="row row5">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content">
          {side('Player A', cards.playerA, isAWinner)}
          {' '}
          <div className="casino-result-content-diveder"></div>
          {' '}
          {side('Player B', cards.playerB, isBWinner)}
        </div>
      </div>
      {' '}
      <div className="col-12 col-lg-5">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div>
            {' '}
            <div>{winner}</div>
          </div>
          {' '}
          {underOver && (
            <div className="casino-result-desc-item">
              <div>Under/Over</div>
              {' '}
              <div>{underOver}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
